/**
 * Text sanitization constants for removing problematic characters and spaces
 * Used for both device-dependent character validation and HTML entity cleanup
 */

/**
 * Device-dependent characters that may cause display issues across different environments
 * These characters should be avoided in article titles and content
 */
export const DEVICE_DEPENDENT_CHARS = {
  units: '㎜㎝㎞㎎㎏㏄',
  units2: '㍉㌔㌢㍍㌘㌧㌃㌶㍑㍗㌍㌦㌣㌫㍊㌻',
  romanNumerals: 'ⅠⅡⅢⅣⅤⅥⅦⅧⅨⅩ',
  specialKanji:
    '纊褜鍈銈蓜俉炻昱棈鋹曻彅丨仡仼伀伃伹佖侒侊侚侔俍偀倢俿倞偆偰偂傔僴僘兊兤冝冾凬刕劜劦勛匀匇匤卲厓厲叝﨎咜咊咩哿喆坙坥垬埈埇﨏',
  symbols: '№㏍℡㊤㊥㊦㊧㊨',
  corporation: '㈱㈲㈹㍾㍽㍼㍻',
  math: 'ⅠⅡⅢⅣⅤ≡∑∫∮√⊥∠∟⊿∵∩∪',
  punctuation: '｡､｢｣',
  halfKana: 'ｱｲｳｴｵｶｷｸｹｺｻｼｽｾｿﾀﾁﾂﾃﾄﾅﾆﾇﾈﾉﾊﾋﾌﾍﾎﾏﾐﾑﾒﾓﾔﾕﾖﾗﾘﾙﾚﾛﾜｦﾝｧｨｩｪｫｬｭｮ',
  utf8Problems: '\uFFF0\uFFF1\uFFF2\uFFF3\uFFF4\uFFF5\uFFF6\uFFF7\uFFF8\uFFF9\uFFFA\uFFFB\uFFFC\uFFFD\uFFFE\uFFFF', // U+FFF0-FFFF
}

/**
 * Special Unicode spaces that should be removed from text
 * These are different from device-dependent characters and are handled separately
 */
export const SPECIAL_SPACES =
  '\u00A0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u200B\u202F\u205F\uFEFF' // Special Unicode spaces (excluding normal space U+0020 & JP space U+3000)

/**
 * HTML entity patterns for special spaces that should be removed
 * Used for cleaning up copy-pasted content that contains HTML entities
 */
export const HTML_ENTITY_SPACE_PATTERNS = [
  /&nbsp;/g, // NO-BREAK SPACE (named entity)
  /&#x00A0;/g, // NO-BREAK SPACE (hex)
  /&#160;/g, // NO-BREAK SPACE (decimal)
  /&#x200B;/g, // ZERO WIDTH SPACE (hex)
  /&#8203;/g, // ZERO WIDTH SPACE (decimal)
  /&#x2002;/g, // EN SPACE (hex)
  /&#8194;/g, // EN SPACE (decimal)
  /&#x2003;/g, // EM SPACE (hex)
  /&#8195;/g, // EM SPACE (decimal)
  /&#x2009;/g, // THIN SPACE (hex)
  /&#8201;/g, // THIN SPACE (decimal)
  /&ensp;/g, // EN SPACE (named entity)
  /&emsp;/g, // EM SPACE (named entity)
  /&thinsp;/g, // THIN SPACE (named entity)
]
